export const DS_ACCORDION_EXPANDED_STORAGE_KEY = "ds_accordion_expanded";
